import React from 'react'
import { PdfPage } from '../styles'
import { Field } from '../../../../components/Input/CheckboxInput/styles'
import { FaTrash, FaArrowLeft, FaArrowRight } from 'react-icons/fa6'

export interface PageItemHandle {
  checkValue: (value: boolean) => void
}

export interface PageItemProps {
  page: any
  list: boolean
  index: number
  onDelete?: () => void
  onMoveLeft?: () => void
  onMoveRight?: () => void
}

const PageItem: React.ForwardRefRenderFunction<PageItemHandle, PageItemProps> = (
  { list, page, index, onDelete, onMoveLeft, onMoveRight },
  ref,
) => {
  const [checked, setChecked] = React.useState(false)

  React.useImperativeHandle(
    ref,
    () => ({
      checkValue(value) {
        setChecked(value)
      },
      checked,
      _id: page._id,
    }),
    [checked, page],
  )

  return (
    <>
      <PdfPage.Content onClick={() => setChecked(!checked)} isList={list} style={{ position: 'relative' }}>
        <PdfPage.Header>
          <Field
            onClick={(e) => {
              e.stopPropagation()
            }}
            onChange={(e) => setChecked(e.target.checked)}
            checked={checked}
            type='checkbox'
          />
          <PdfPage.Title>Página {index + 1}</PdfPage.Title>
        </PdfPage.Header>
        <PdfPage.Image isList={list} key={`page-${index}`} src={page.url || page} />
        
        {/* Controles Overlay */}
        <div style={{ position: 'absolute', bottom: 10, left: 0, width: '100%', display: 'flex', justifyContent: 'center', gap: '10px' }} onClick={e => e.stopPropagation()}>
          <button onClick={(e) => { e.stopPropagation(); onMoveLeft && onMoveLeft() }} style={{ background: '#333', color: 'white', border: 'none', borderRadius: '50%', width: 30, height: 30, cursor: 'pointer' }}><FaArrowLeft /></button>
          <button onClick={(e) => { e.stopPropagation(); onDelete && onDelete() }} style={{ background: '#dc3545', color: 'white', border: 'none', borderRadius: '50%', width: 30, height: 30, cursor: 'pointer' }}><FaTrash /></button>
          <button onClick={(e) => { e.stopPropagation(); onMoveRight && onMoveRight() }} style={{ background: '#333', color: 'white', border: 'none', borderRadius: '50%', width: 30, height: 30, cursor: 'pointer' }}><FaArrowRight /></button>
        </div>
      </PdfPage.Content>
    </>
  )
}

export default React.forwardRef(PageItem)
